const t = /* @__PURE__ */ new WeakSet();
function n(e) {
  t.add(e);
}
function f(e) {
  return !t.has(e);
}
export {
  f as eventEffectNotPerformed,
  n as markEventEffectPerformed
};
